<template>
    <SimpleButton @click="payOrder(props.orderId, props.method)" class="px-3 py-1 text-xs font-medium uppercase shrink-0" :disabled="waitingResponse">Оплатить
        <span v-if="props.method == 'sbp'" class="pl-1">по СБП</span></SimpleButton>
</template>

<script setup lang="ts">

import { ref } from 'vue'

const props = withDefaults(defineProps<{
    orderId: number,
    method?: string,
}>(), {
    method: '',
})

const waitingResponse = ref(false)
const privateAxios = usePrivateAxiosInstance()
const payOrder = async (orderId: number, method: string) => {
    waitingResponse.value = true
    let url = 'user/order/'+orderId+'/get-payment-url'
    if(method.length > 0) {
        url += "/"+method
    }
    const response = await privateAxios.get<string>(url).finally(() => {
        waitingResponse.value = false
    })

    if (response.data.payment_confirmation_url.length > 0) {
        navigateTo(response.data.payment_confirmation_url, {
            external: true,
        })
    }

    return response.data
}
</script>
